/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_G5Inputs */

const en_mk_mx_g5 = /** @type {(inputs: Mk_Mx_G5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security & administration`)
};

const id_mk_mx_g5 = /** @type {(inputs: Mk_Mx_G5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keamanan & administrasi`)
};

/**
* | output |
* | --- |
* | "Security & administration" |
*
* @param {Mk_Mx_G5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_g5 = /** @type {((inputs?: Mk_Mx_G5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_G5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_g5(inputs)
	return en_mk_mx_g5(inputs)
});